import { OptionProps } from 'react-select';

import { paradigmLightBlue } from '@paradigm/design-system/src/colors';

import { Option } from '@paradigm/design-system/src/components/Select';

import { AccountOption } from '../types';

export default function CustomAccountOption(
  props: OptionProps<AccountOption, false>,
) {
  const { label, isDefault } = props.data;
  return (
    <Option {...props} className="d-flex justify-content-between w-100 pointer">
      <div className="flex-1 text-truncate mr-1">{label}</div>
      <div
        className="d-flex align-items-center"
        style={{ color: paradigmLightBlue, fontSize: 12 }}
      >
        {isDefault && (
          <div className="mr-1 opacity-5" style={{ color: 'white' }}>
            Default
          </div>
        )}
      </div>
    </Option>
  );
}
